// TODO: This is temporary implementation to re-use existing cashier code. After CXD approval should be combined with <StarsInfo /> for consistency.

import Typography from '@mui/material/Typography';
import { InfoIcon } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import SuccessIcon from '@swf/core/assets/icons/success.svg';
import WarningIcon from '@swf/core/assets/icons/warning-triangle.svg';
import ErrorIcon from '@swf/core/assets/icons/warning.svg';

import {
  blankAlert,
  errorAlert,
  errorIcon,
  firstAlert,
  infoAlert,
  infoIcon,
  successAlert,
  successIcon,
  warningAlert,
  warningIcon
} from './Alert.scss';

export interface AlertVariant {
  variant:
    | 'blank'
    | 'celebration'
    | 'default'
    | 'error'
    | 'first'
    | 'info'
    | 'loading'
    | 'success'
    | 'warning';
}

interface Props extends AlertVariant, React.PropsWithChildren {
  className?: string;
}

const icons: Partial<Record<AlertVariant['variant'], JSX.Element>> = {
  error: <ErrorIcon className={errorIcon} />,
  info: <InfoIcon className={infoIcon} />,
  warning: <WarningIcon className={warningIcon} />,
  success: <SuccessIcon className={successIcon} />
};

const alerts: Partial<Record<AlertVariant['variant'], string>> = {
  blank: blankAlert,
  error: errorAlert,
  first: firstAlert,
  info: infoAlert,
  success: successAlert,
  warning: warningAlert
};

const Alert: React.FC<Props> = ({ variant, children, className }) => (
  <Typography component="div" classes={{ root: classNames(alerts[variant], className) }}>
    {icons[variant]}
    <div>{children}</div>
  </Typography>
);

export default Alert;
